export default "__VITE_ASSET__D3K1bUTA__"